import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import NoDataImg from '../../media/no-data.svg';
import { getAudienceNoDataStyle } from '../styles/audience-no-data';

const UnstyledAudienceNoDataView = (props) => {
  const {
    classes,
    i18n,
  } = props;

  return (
    <div className={classNames(['audience-no-data', classes.container])}>
      <img className="no-data-img" src={NoDataImg} alt="" />
      <div className="no-data-title">
        {i18n.getString(_TL_('Nothing to see here'))}
      </div>
      <div className="no-data-description">
        {i18n.getString(_TL_('You haven\'t added any audience signals yet.'))}
      </div>
      <div className="no-data-description">
        {i18n.getString(_TL_('Once you create one, you\'ll see it here.'))}
      </div>
    </div>
  );
};

UnstyledAudienceNoDataView.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

export const AudienceNoDataView = withDefaultStyles(UnstyledAudienceNoDataView, getAudienceNoDataStyle);
